export const environment = {
    production: false,
    // Same-origin in dev so ng proxy / SWA emulator can forward API calls server-side.
//dashApiUrl: 'https://dash-api-dev.azurewebsites.net',
recaptchaSiteKey : '6Lck21EtAAAAAOJj5LMj59UzDJvhF_8kZGJaunbZ',
    dashApiUrl: 'https://dash-api-dev.sb-court.org',
    // dashApiUrl: 'https://localhost:7011',
};
